import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Loader2 } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { api } from "@/lib/api";

const EASE = [0.22, 1, 0.36, 1];

export default function InfoDetailPage() {
  const { id } = useParams();
  const [item, setItem] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    api.get(`/gallery/${id}`)
      .then((r) => setItem(r.data))
      .catch(() => setMissing(true));
  }, [id]);

  return (
    <div data-testid="info-detail-page" className="min-h-screen bg-slate-50">
      <Navbar />
      <main className="mx-auto max-w-3xl px-6 pb-28 pt-32 sm:px-10">
        <Link
          to="/gallery"
          data-testid="info-back-link"
          className="inline-flex items-center gap-2 text-sm font-bold text-sky-700 transition-colors duration-200 hover:text-sky-900"
        >
          <ArrowLeft size={15} /> Back to gallery
        </Link>

        {missing ? (
          <p className="mt-14 rounded-3xl border border-dashed border-slate-300 p-10 text-center text-slate-500" data-testid="info-not-found">
            This information card could not be found.
          </p>
        ) : item === null ? (
          <div className="mt-14 flex items-center gap-3 text-slate-500" data-testid="info-loading">
            <Loader2 size={18} className="animate-spin" /> Loading…
          </div>
        ) : (
          <motion.article
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: EASE }}
            className="mt-10"
            data-testid="info-article"
          >
            <span className="rounded-full bg-sky-100 px-3 py-1 text-[11px] font-bold uppercase tracking-widest text-sky-800">
              {item.category}
            </span>
            <h1 className="mt-5 font-display text-3xl font-bold leading-tight tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
              {item.title}
            </h1>
            <p className="mt-6 border-l-4 border-amber-400 pl-5 font-display text-lg italic leading-relaxed text-slate-700 sm:text-xl">
              {item.summary}
            </p>
            <div className="mt-8 rounded-3xl border border-slate-200 bg-white p-8 shadow-sm sm:p-10">
              <p className="whitespace-pre-line text-base leading-loose text-slate-700" data-testid="info-details">
                {item.details}
              </p>
            </div>
          </motion.article>
        )}
      </main>
      <Footer />
    </div>
  );
}
